// i THINK, this is grabbing everything in this specific State that was passed down from index.js in the store. 
// to be passed down to the components. 
export const mapStateToProps = (state)=>{
    return{
      mappedMenu: state.menuReducer,
      mappedCharacter: state.characterPageReducer,
      mappedComicPage:state.comicPageReducer,
      mappedCharacterDatabase:state.characterDatabaseReducer,
      mappedPagination:state.paginationReducer,
      mappedComicDatabase:state.comicDatabaseReducer,
      mappedVideos:state.videoReducer
    };
  }
  
  
  //this allows you to use attach functions to props. That way they can be passed down into components 
  //and fired from them, allowing you to point the dispatch:type to whatever reducer. Jesus
  //so here, setGirls is just like any other function we'd  create in this Class.
  //Its sole purpose is calling whatever function in the reducer
  //Whatever we do here sends a state change to the Reducer. Then mapStateToProps() will update, and then update 
  //whatever props are currently being rendered. Who the F wrote this thing?!
  export const mapDispatchToProps = (dispatch)=>{
    return{
        changeCurrentPage: (page)=>{
            dispatch({
                type:"CHANGE-CURRENT-PAGE",
                payload: page 
            });
        },
        changeCharacter: (newHero)=>{
            //whatever JS can go here. I guess
            dispatch({
                    type:"CHANGEHERO",
                    payload: newHero 
            });
        },
        changeFeaturedComics: (newComics)=>{
            //whatever JS can go here. I guess
            //console.log("%cFunction Being Called", "color: fff; background:blue;padding:6px");
            dispatch({
                    type:"CHANGE-FEATURED-COMICS",
                    payload: newComics 
            });
        },
        changeRelatedCharacters: (newCharacters)=>{
            //whatever JS can go here. I guess
            //console.log("%cFunction Being Called", "color: fff; background:green;padding:6px");
            dispatch({
                    type:"CHANGE-RELATED-CHARACTERS",
                    payload: newCharacters 
            });
        },
        showFeaturedArea: (showOrNo)=>{
            //whatever JS can go here. I guess
            //console.log("%cshow featured Area", "color: #000; background:orange;padding:6px");
           // console.log(showOrNo);
            dispatch({
                    type:"SHOW-FEATURED",
                    payload: showOrNo 
            });
        },
        showCharacterPopup: (showOrNo)=>{
            //whatever JS can go here. I guess
            //console.log("%cshow featured Area", "color: #000; background:orange;padding:6px");
            //console.log("Character popup: " + showOrNo);
            dispatch({
                    type:"SHOW-CHARACTER-POPUP",
                    payload: showOrNo 
            });
        },
        showComicArea: (showOrNo)=>{
            //whatever JS can go here. I guess
           // console.log("%cshow featured Area", "color: #fff; background:purple;padding:6px");
            //console.log(showOrNo);
            dispatch({
                    type:"SHOW-COMICS",
                    payload: showOrNo 
            });
        },        
        changeMainComic: (mainComicArray)=>{
            //whatever JS can go here. I guess
            //console.log("%cChange Main Comic", "color: #fff; background:purple;padding:6px");
            //console.log(mainComicArray);
            dispatch({
                    type:"CHANGE-MAIN-COMIC",
                    payload: mainComicArray 
            });
            return;
        },        
        changeCharactersInComic: (charactersArray)=>{
            //whatever JS can go here. I guess
            //console.log("%c Change Characters in Main Comic", "color: #fff; background:purple;padding:6px");
            //console.log(charactersArray);
            dispatch({
                    type:"CHANGE-CHARACTERS-IN-COMIC",
                    payload: charactersArray 
            });
        },        
        changeCharacterDatabase: (characterDatabaseArray)=>{
            //whatever JS can go here. I guess
           // console.log("%c Change Character Database", "color: #fff; background:purple;padding:6px");
            //console.log(characterDatabaseArray);
            dispatch({
                    type:"CHANGE-CHARACTER-DATABASE",
                    payload: characterDatabaseArray 
            });
        },        
        showCharacterDatabase: (showOrNo)=>{
            //whatever JS can go here. I guess
            //console.log("%c SHOW CHARACTER  DATABASE", "color: #fff; background:purple;padding:6px",showOrNo);
            dispatch({
                    type:"SHOW-DATABASE-CHARACTERS",
                    payload: showOrNo 
            });
        },        
        changePaginationPage: (page)=>{
            //whatever JS can go here. I guess
            //console.log("%c SHOW CHARACTER  DATABASE", "color: #fff; background:purple;padding:6px",showOrNo);
            dispatch({
                    type:"CHANGE-CURRENT-PAGE",
                    payload: page 
            });
        },        
        changePaginationOffset: (page)=>{
            //whatever JS can go here. I guess
            //console.log("%c SHOW CHARACTER  DATABASE", "color: #fff; background:purple;padding:6px",showOrNo);
            dispatch({
                    type:"CHANGE-OFFSET",
                    payload: page 
            });
        },        
        changeCharacterLetter: (letter)=>{
            //whatever JS can go here. I guess
            //console.log("%c Change current letter", "color: #fff; background:purple;padding:6px",letter);
            dispatch({
                    type:"CHANGE-LETTER",
                    payload: letter 
            });
        }, 
        //////////////////////////////////////////////////////////////COMIC DATABASE FUNCTIONS()
        //////////////////////////////////////////////////////////////COMIC DATABASE FUNCTIONS()
        //////////////////////////////////////////////////////////////COMIC DATABASE FUNCTIONS()
        //////////////////////////////////////////////////////////////COMIC DATABASE FUNCTIONS()
        //////////////////////////////////////////////////////////////COMIC DATABASE FUNCTIONS()
        //////////////////////////////////////////////////////////////COMIC DATABASE FUNCTIONS()
        //////////////////////////////////////////////////////////////COMIC DATABASE FUNCTIONS()      
        changeComicDatabase: (comicDatabaseArray)=>{
            //whatever JS can go here. I guess
           // console.log("%c Change COMIC Database", "color: red; background:pink;padding:6px");
            //console.log(comicDatabaseArray);
            dispatch({
                    type:"CHANGE-COMIC-DATABASE",
                    payload: comicDatabaseArray 
            });
        },        
        showComicDatabase: (showOrNo)=>{
            //whatever JS can go here. I guess
            //console.log("%c SHOW CHARACTER  DATABASE", "color: #fff; background:purple;padding:6px",showOrNo);
            dispatch({
                    type:"SHOW-DATABASE-COMICS",
                    payload: showOrNo 
            });
        },         
        changeComicPaginationPage: (page)=>{
            //whatever JS can go here. I guess
            //console.log("%c SHOW CHARACTER  DATABASE", "color: #fff; background:purple;padding:6px",showOrNo);
            dispatch({
                    type:"COMIC-CHANGE-CURRENT-PAGE",
                    payload: page 
            });
        },        
        changeComicPaginationOffset: (page)=>{
            //whatever JS can go here. I guess
            //console.log("%c SHOW CHARACTER  DATABASE", "color: #fff; background:purple;padding:6px",showOrNo);
            dispatch({
                    type:"COMIC-CHANGE-OFFSET",
                    payload: page 
            });
        },        
        changeComicLetter: (letter)=>{
            //whatever JS can go here. I guess
            //console.log("%c Change current letter", "color: #fff; background:purple;padding:6px",letter);
            dispatch({
                    type:"COMIC-CHANGE-LETTER",
                    payload: letter 
            });
        }, 
        //////////////////////////////////////////////////////////////VIDEO FUNCTIONS()
        //////////////////////////////////////////////////////////////VIDEO FUNCTIONS()
        //////////////////////////////////////////////////////////////VIDEO FUNCTIONS()
        //////////////////////////////////////////////////////////////VIDEO FUNCTIONS()
        //////////////////////////////////////////////////////////////VIDEO FUNCTIONS()
        //////////////////////////////////////////////////////////////VIDEO FUNCTIONS()
        //////////////////////////////////////////////////////////////VIDEO FUNCTIONS()        
        changeVideos: (videos)=>{
            //whatever JS can go here. I guess
            //console.log("%c Change current Videos", "color: red; background:#fff;padding:6px",videos);
            dispatch({
                    type:"CHANGEVIDEOS",
                    payload: videos 
            });
        },
        showVideos: (videos)=>{
            //whatever JS can go here. I guess
            //console.log("%c Show Videos", "color: #fff; background:#000;padding:6px",videos);
            dispatch({
                    type:"SHOW-VIDEOS",
                    payload: videos 
            });
        },
        changeSelectedVideo: (videoID)=>{
            //whatever JS can go here. I guess
            //console.log("%c Selected Video", "color: #fff; background:purple;padding:6px",videoID);
            dispatch({
                    type:"CHANGE-SELECTED-VIDEO",
                    payload: videoID 
            });
        },
        changeVideoPopupVisibility: (isVisible)=>{
            //whatever JS can go here. I guess
            //console.log("%c Show Popup", "color: #fff; background:red;padding:6px",isVisible);
            dispatch({
                    type:"CHANGE-VIDEO-POPUP-VISIBILITY",
                    payload: isVisible 
            });
        }
    };
  }

  


// WEBPACK FOOTER //
// ./src/dispatchers.js